import { render } from "./FormChooseTopic.vue?vue&type=template&id=f05111c6&scoped=true"
import script from "./FormChooseTopic.vue?vue&type=script&lang=js"
export * from "./FormChooseTopic.vue?vue&type=script&lang=js"

import "./FormChooseTopic.vue?vue&type=style&index=0&id=f05111c6&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/wdw-vue build and deploy Teledata PROD/wdw-vue-widgets/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f05111c6"]])

export default __exports__